import React from 'react'
import { Box, Flex } from 'grid-styled'
import { ISODateFormat, currencyParser } from 'alelo-logic/utils'
import Hide from '../../../styles/utilities/Hide'

import { ListItem, Content, Label, Title } from './styles'

import labels from './data.json'

const RechargeListItem = ({ date, paymentMethod, type, value }) => (
  <ListItem id="litRechargeItem">
    <Content>
      <Flex width={1}>
        <Box width={[6 / 12, 1 / 12]} mr={70}>
          <Label name="recharge-item-date-label">{labels.title.date}</Label>
          <Title className="date" name="recharge-item-date">
            {ISODateFormat(date, 'DD/MM/YYYY')}
          </Title>
        </Box>
        <Hide at="small" width={[1 / 12]} mr={25}>
          <Label name="recharge-item-hour-label">{labels.title.hour}</Label>
          <Title name="recharge-item-hour">{ISODateFormat(date, 'HH:mm')}</Title>
        </Hide>
        <Hide at="small" width={[3 / 12]} mr={12}>
          <Label name="recharge-item-payment-label">{labels.title.payment}</Label>
          <Title>{labels.paymentMethod[paymentMethod]}</Title>
        </Hide>
        <Hide at="small" width={[4 / 12]} mr={10}>
          <Label name="recharge-item-type-label">{labels.title.type}</Label>
          <Title>{labels.type[type]}</Title>
        </Hide>
        <Box width={[6 / 12, 1 / 12]}>
          <Label name="recharge-item-value-label">{labels.title.value}</Label>
          <Title>{currencyParser(value)}</Title>
        </Box>
      </Flex>
    </Content>
  </ListItem>
)

export default RechargeListItem



// WEBPACK FOOTER //
// ./src/app/elements/RechargeListItem/index.js